import getKeyValuePair from './keyValuePair';

export default function readKeyValuePairs ( parser ) {
	var start = parser.pos;

	var pair = getKeyValuePair( parser );
	if ( pair === null ) {
		return null;
	}

	var pairs = [ pair ];

	if ( parser.matchString( ',' ) ) {
		var keyValuePairs = readKeyValuePairs( parser );

		if ( !keyValuePairs ) {
			parser.pos = start;
			return null;
		}

		return pairs.concat( keyValuePairs );
	}

	return pairs;
}

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/parse/converters/expressions/primary/literal/objectLiteral/keyValuePairs.js.map
